var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"alert_",attrs:{"color":"error","dense":"","text":""}},[_c('span',{staticClass:"overline",domProps:{"textContent":_vm._s(_vm.order)}})])}
var staticRenderFns = []

export { render, staticRenderFns }